import axiosInstance from 'utils/axiosInstance';
import { get } from 'lodash/fp';

const getBalance = data => axiosInstance.post('/api/Payout/balance', data).then(get('data'));

export { getBalance };
